export const BASE_URI: Readonly<string> = 'https://node.deso.org/api/v0';
export const BASE_IDENTITY_URI: Readonly<string> = 'https://identity.deso.org';
